module.exports = __webpack_public_path__ + "static/img/1.df8b996.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/1.png
// module id = dIj2
// module chunks = 0